export class OrganisationSettingData {
  //individualVerificationEnabled: boolean;

  constructor(data: Partial<OrganisationSettingData> = {}) {
   // this.individualVerificationEnabled = data.individualVerificationEnabled ?? false;
  }
}
